// $('head').append('<link rel="stylesheet" href="fontawesome-all.min.css"/>');
//Navigation
!function(i){i.fn.menumaker=function(n){var e=i(this),s=i.extend({title:"Menu",format:"language-changer",sticky:!1},n);return this.each(function(){return e.find("li ul, li .mega-dropdown").parent().addClass("has-sub"),multiTg=function(){e.find(".has-sub").prepend('<span class="submenu-button"></span>'),e.find(".submenu-button").on("click",function(){$(i(this)).text(($(i(this)).text() == '') ? i(this).next().text():'');i(this).toggleClass("submenu-opened"),i(this).parent().toggleClass("parent-active"),i(this).siblings("ul,.mega-dropdown").hasClass("open")?i(this).siblings("ul,.mega-dropdown").removeClass("open").hide():i(this).siblings("ul,.mega-dropdown").addClass("open").show()})},"multitoggle"===s.format?multiTg():e.addClass("language-changer"),s.sticky===!0&&e.css("position","fixed"),resizeFix=function(){i(window).width()>1024&&e.find("ul,.mega-dropdown").show(),i(window).width()<=1024&&e.find("ul,.mega-dropdown").hide().removeClass("open")},function(){$(window).width()>1024?(resizeFix("resize"),i(window).on(resizeFix)):(resizeFix(),i(window).on(resizeFix))}})}}($),function(i){i(document).ready(function(){$(".mega-dropdown").parent().addClass("has-mega"),i("#push_sidebar").menumaker({title:"",format:"multitoggle"})})}(jQuery);
// For small screen Nav
jQuery(document).mouseup(function(a){	
var f=jQuery(a.target).closest(".nav-trigger"),g=jQuery(a.target).closest("#push_sidebar");f.length?(a.preventDefault(),jQuery("html").toggleClass('sidebar_active'),jQuery(".nav-trigger").toggleClass("closemenu")):g.length||(jQuery("html").removeClass('sidebar_active'),jQuery(".nav-trigger").removeClass("closemenu"))});
// For menu position
function isTouchDevice(){return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);}if(isTouchDevice()===true){}else{jQuery(window).on('load', function(){setTimeout(function() {jQuery("ul.nav > li.has-sub").hover(function(){var s=jQuery("header").offset(),t=jQuery("header").width(),e=s.left+t,i=jQuery(this).find(".submenu-button").siblings("ul").offset(),n=jQuery(this).find(".submenu-button").siblings("ul").width();e<i.left+n&&jQuery(this).addClass("align-left-menu")},function(){jQuery(this).removeClass("align-left-menu")}),jQuery("ul.nav ul li.has-sub").hover(function(){var s=jQuery("header").offset(),t=jQuery("header").width(),e=s.left,i=e+t,n=jQuery(this).find(".submenu-button").siblings("ul").offset(),l=jQuery(this).find(".submenu-button").siblings("ul").width(),u=n.left;i<u+l&&(jQuery(this).addClass("align-left-menu")),e>u&&jQuery(this).addClass("align-right-menu")},function(){jQuery(this).removeClass("align-left-menu"),jQuery(this).removeClass("align-right-menu")}),jQuery(".nav-wrap nav ul.nav ul .has-sub").each(function(iz) {jQuery(this).css("z-index","500"-iz);});},200);});}
navFuc = function(){
$(".nav-wrap nav ul.nav > li" ).each(function() {
 // wheight=$( window ).height();
  wwidth=$(window).width();
  pwidth=$("header .container").width();    
  dwidth =wwidth-pwidth;    
  thewidth=dwidth/2;
  thePos = $(this).offset().left-thewidth;
  $(this).find(".mega-dropdown").css("left",- thePos-1)
  $(".mega-dropdown").css("width",pwidth);   
});
};
$(document).ready(function() {
navFuc();
setTimeout(function() {
navFuc();
},300 );
});
$(window).resize(function(){
navFuc();
setTimeout(function() {
navFuc();
},300 );
});
//Navigation End

// Click Dropdown
$(document).on('click touchstart',function(fd){
	var click_box = $(".search-close, .search-triger, .search-wrap");
    if (!click_box.is(fd.target) && click_box.has(fd.target).length === 0) 
    {
      jQuery('.search-close, .search-triger,.search-close').removeClass("active");
     jQuery(".search-wrap").fadeOut();
}
});


//Sidbar
jQuery('.small-screen-icon').click(function(){
jQuery(this).toggleClass("active");
jQuery(this).next().slideToggle();
});

//Search
jQuery('.search-triger').click(function(){
jQuery(this).toggleClass("active");
jQuery(".search-wrap").fadeToggle();
});

// Header Shrink
$(function(){function b(){return window.pageYOffset||document.documentElement.scrollTop}$(window).scroll(function(){b()>=1?($("html").addClass("head-fix")):($("html").removeClass("head-fix"))})});
// Header Shrink End

// On Scroll Class Add
// Background set
$(".bg img").each(function(da){var db=$(this).attr("src");$(this).parent().css("background-image","url("+db+")")});
// Scroll Top Js
var offset=0,duration=500;$(window).scroll(function(){$(this).scrollTop()>offset?$(".scrollup").fadeIn():$(".scrollup").fadeOut()}),$(".scrollup").click(function(a){return a.preventDefault(),$("html, body").animate({scrollTop:0},duration),!1});

// class adding in image
$(".alignright,.alignleft").closest("p").addClass("pn")

// Table wrap
$("table").wrap("<div class='table-responsive'></div>");

// Heading wrap
$(".blue-box h3").wrapInner("<small></small>");


// Lazy load
$(function(a){var b=function(){a("[data-image]").each(function(){var b=a(this).offset().top,c=a(window).scrollTop(),d=a(window).height(),e=b-c<d;e&&(a(this).attr("src",a(this).attr("data-image")).removeClass("lazy"),a(this).attr("src",a(this).attr("data-src")).addClass("lazyFade"))})};a(function(){b(),a(window).scroll(function(){b()}),a(window).on("load", function () {b()})})});


//All Function

//Devicewidth
function minus_margin(){
ww = $(window).width();	
cw = $("header .container").outerWidth();
dcw = ww-cw;
doww= dcw/2+15;
jQuery(".padding-right").css('padding-right',doww);
jQuery(".padding-left").css('padding-left',doww);

jQuery(".margin-right").css('margin-right',-doww);
jQuery(".margin-left").css('margin-left',-doww);


}
minus_margin();




// Window Load Function
$(window).on("load", function () {
//Captcha 	


});
// Window Resize Function
$(window).on("resize", function () {

minus_margin();

});
jQuery(document).ready(function() {
$('footer .row div:first-of-type .mobile-collapse').css('display','block');
$('.collapse-triger:first').addClass('active');
$('.mobile-collapse:first').addClass('active');
$('.collapse-triger').click(function(){
$(this).toggleClass('active');
$(this).next('.mobile-collapse').slideToggle('100').toggleClass('active');
})
});
// Accordian
$('.all-faq:first-of-type .accordion-data:first-of-type .accordion-head').addClass('active');
$('.all-faq:first-of-type .accordion-data:first-of-type .accordion-content').slideDown().addClass('active');

$('.accordion-data').click(function () {
    if ($(this).children('.accordion-content').hasClass("active")) {
        $(this).children('.accordion-head').removeClass('active');
        $(this).children('.accordion-content').slideUp().removeClass('active');
    } else {
       
        $(this).parent().find(".accordion-head").removeClass('active');
         $(this).parent().find('.accordion-content').slideUp().removeClass('active');
		$(this).children('.accordion-head').addClass('active');
        $(this).children('.accordion-content').slideDown().addClass('active');
    }
});

//Filter
$('.filter-aside:first-of-type .filter-head:first-of-type').addClass('active');
$('.filter-aside:first-of-type .filter-content:first-of-type').slideDown().addClass('active');
$('.filter-head').click(function(){	
if($(this).next('.filter-content').hasClass("active")){
$(this).removeClass('active');
$(this).next('.filter-content').slideUp().removeClass('active');
}else{
//$('.filter-content').slideUp().removeClass('active');
//$('.filter-head').removeClass('active');
$(this).addClass('active');
$(this).next('.filter-content').slideDown().addClass('active');
}
}); 


// Smooth scroll
$('.smooth, ul.alphabet-links a').click(function(event) {
       if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && location.hostname == this.hostname
       ) {

      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top-140
        }, 1000);
      }
    }
  });
  $('.custom-panel').on('shown.bs.collapse', function (e) {
var panelHeadingHeight = $('.custom-panel .panel-heading').height();
var animationSpeed = 500; // animation speed in milliseconds
var currentScrollbarPosition = $(document).scrollTop();
var topOfPanelContent = $(e.target).offset().top;
if ( currentScrollbarPosition >  topOfPanelContent - panelHeadingHeight) {
$("html, body").animate({ scrollTop: topOfPanelContent - panelHeadingHeight-150 }, animationSpeed);
}});

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
});
document.addEventListener('DOMContentLoaded', () => {
  // Select the specific form to be watched
  const formToObserve = document.querySelector('.blog-search-form');

  if (formToObserve) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        // We only care about attribute changes on the input element
        if (mutation.type === 'attributes' && mutation.target.tagName === 'INPUT') {
          const input = mutation.target;

          // Check if the Boost AI specific class has been added
          if (input.classList.contains('boost-sd__search-widget-init-input')) {
            // Remove the Boost AI specific classes and attributes
            input.classList.remove('boost-sd__search-widget-init-input');
            input.removeAttribute('id');
            input.removeAttribute('data-search-box');
            input.removeAttribute('role');
            input.removeAttribute('aria-expanded');
            input.removeAttribute('aria-autocomplete');
            input.removeAttribute('aria-owns');
            input.removeAttribute('maxlength');

            // Optionally, we can also disconnect the observer once we've done our job
            // to avoid unnecessary processing
            observer.disconnect();

            // Replace the element to remove any attached event listeners
            // This is a crucial step to fully neutralize the Boost AI script
            const clonedInput = input.cloneNode(true);
            input.parentNode.replaceChild(clonedInput, input);
            
            console.log('Boost AI search functionality successfully removed from blog sidebar.');
          }
        }
      }
    });

    // Start observing the form for attribute changes on its descendants
    observer.observe(formToObserve, {
      attributes: true,       // Watch for attribute changes
      subtree: true           // Watch for changes in all descendants of the form
    });
  }
});